import service from '../config/axios.config';
import { addAlert } from './alerts.action';
import { CHECK_HASH_SUCCESS } from '../actions/registration.action';

const alertMessageStart = 'forgotten_password.alert.';

export const DELETE_EMPLOYEES = 'cx-ray/EMPLOYEE/PASSWORD/DELETE_EMPLOYEES';

export function sendForgottenPassword(userName, history) {
  return async dispatch => {
    const url = `/sendPasswordChange`;
    service.post(url, userName)
      .then(result => {
        dispatch(
          addAlert({
            message: `${alertMessageStart}${result.data.message}`,
            severity: 'success'
          })
        );
        history.push('/');
      })
      .catch(error => {
        dispatch(
          addAlert({ message: `${alertMessageStart}${error.message}`, severity: 'error' })
        );
      });
  };
};

export function checkResetHash(resetHash) {
  return async dispatch => {
    const url = `/changePassword/${resetHash}`;
    service.get(url)
      .then(result => {
        dispatch({
          type: CHECK_HASH_SUCCESS,
          payload: result.data });
      })
      .catch(error => {
        dispatch(
          addAlert({ message: `${alertMessageStart}${error.message}`, severity: 'error' })
        );
      });
  };
};

export function changePassword(resetHash, password, history) {
  return async dispatch => {
    const url = `/changePassword/${resetHash}`;
    service.post(url, password)
      .then(result => {
        dispatch({
          type: DELETE_EMPLOYEES,
          payload: result.data });
        dispatch(
          addAlert({
            message: `${alertMessageStart}${result.data.message}`,
            severity: 'success'
          })
        );
        history.push('/');
      })
      .catch(error => {
        dispatch(
          addAlert({ message: `${alertMessageStart}${error.message}`, severity: 'error' })
        );
      });
  };
};
